/* eslint-disable */
import axios from "axios";
import CommonClass from "../js/common";

const API_ROOT = CommonClass.api_url;

//let token = null;
// const tokenPlugin = req => {
//   if (token) {
//     req.set('authorization', `Token ${token}`);
//   }
// }

const Auth = {
  register: (FirstName, LastName, email) =>
    axios
      .post(API_ROOT + "/users/registration", {
        email: email,
        FirstName: FirstName,
        LastName: LastName
      })
      .then(response => {
        return response;
      }),
  invite: (FirstName, LastName, email, UserType) =>
    axios
      .post(API_ROOT + "/users/invite", {
        email: email,
        FirstName: FirstName,
        LastName: LastName,
        UserType: UserType
      })
      .then(response => {
        return response;
      })
};

export default {
  Auth
  // setToken: _token => { token = _token; }
};



// WEBPACK FOOTER //
// src/actions/index.js